const statuses = {
    DEFAULT: 'DEFAULT',
    PENDING: 'PENDING',
    SUCCESS: 'SUCCESS',
    ERROR: 'ERROR',
    DISABLED: 'DISABLED',
};

export default statuses;
